(function () {
  if (window.speedChatLauncherInstalled) return;
  var source = document.querySelector('script[data-speed-chat-script]');
  var shop = source && source.getAttribute('data-shop');
  if (!shop || !/^[a-z0-9-]+\.myshopify\.com$/.test(shop)) return;
  window.speedChatLauncherInstalled = true;
  var launcher = document.querySelector('[data-speed-chat-launcher]');
  var button = launcher && launcher.querySelector('[data-speed-chat-open]');
  var fallback = launcher && launcher.querySelector('[data-speed-chat-fallback]');
  var started = false;
  var requested = false;
  var ready = false;
  var initializing = false;
  var timer;
  var failureTimer;

  function showFallback() {
    clearTimeout(failureTimer);
    if (button) button.removeAttribute('aria-busy');
    if (fallback) fallback.hidden = false;
  }

  function openChat() {
    if (!requested || !ready || !window.GorgiasChat) return;
    requested = false;
    try { window.GorgiasChat.open(); }
    catch (error) { if (launcher) launcher.hidden = false; showFallback(); }
  }

  function initialize() {
    if (ready) { openChat(); return; }
    if (initializing || !window.GorgiasChat) return;
    initializing = true;
    Promise.resolve().then(function () { return window.GorgiasChat.init(); }).then(function () {
      ready = true;
      clearTimeout(failureTimer);
      if (launcher) launcher.hidden = true;
      openChat();
    }).catch(function () { initializing = false; showFallback(); });
  }

  function start() {
    if (document.hidden && !requested) return;
    clearTimeout(timer);
    if (started) { initialize(); return; }
    started = true;
    window.addEventListener('gorgias-widget-loaded', initialize);
    var existing = document.querySelector('script[data-gorgias-loader-chat]');
    if (existing) { initialize(); return; }
    var script = document.createElement('script');
    script.src = 'https://config.gorgias.chat/bundle-loader/shopify/' + shop;
    script.async = true;
    script.setAttribute('data-gorgias-loader-chat', '');
    script.addEventListener('error', showFallback, { once: true });
    document.head.appendChild(script);
  }

  if (button) button.addEventListener('click', function () {
    requested = true;
    button.setAttribute('aria-busy', 'true');
    failureTimer = setTimeout(showFallback, 20000);
    start();
  });

  function idleStart() {
    timer = setTimeout(function () {
      if (window.requestIdleCallback) window.requestIdleCallback(start, { timeout: 2000 });
      else start();
    }, 8000);
  }
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden && !started) idleStart();
  });
  if (document.readyState === 'complete') idleStart();
  else window.addEventListener('load', idleStart, { once: true });
})();
